import { Component, OnInit } from '@angular/core';
import { SearchResult } from 'src/app/interfaces/search-result';
import { UnsubscriberComponent } from 'src/app/components/shared/unsubscriber.component';
import { SearchService } from 'src/app/services/search.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { NavigateService } from 'src/app/services/navigate.service';

@Component({
    selector: 'app-search-result-wrap',
    templateUrl: './results.component.html',
    styleUrls: ['./results.component.scss'],
    standalone: false
})
export class SearchResultsComponent
  extends UnsubscriberComponent
  implements OnInit {
  public items: SearchResult[];
  public message: string;
  public showSkeleton: Observable<boolean>;

  constructor(
    private searchService: SearchService,
    private navigateService: NavigateService,
    private router: Router,
    private route: ActivatedRoute
  ) {
    super();
  }

  ngOnInit() {
    this.subscriptions.add(
      this.searchService.searchData$.subscribe((items) => {
        this.items = items;
        this.message = items.length ? '' : 'Not found';
      })
    );

    this.subscriptions.add(
      this.route.queryParams.subscribe((params) => {
        if (params['query'] && history.state['reason'] !== 'submit') {
          this.getSearchResults(params['query']);
        }
      })
    );

    this.showSkeleton = this.searchService.searchInProgress$;
  }

  getSearchResults(query: string): void {
    this.subscriptions.add(
      this.searchService
        .search(query)
        .subscribe((data) => this.searchService.setSearchData(data))
    );
  }

  handleItem(item: SearchResult): void {
    history.state['reason'] === 'submit'
      ? this.navigateToItem(item)
      : this.items.push(item);
  }

  navigateToItem(item) {
    //this.searchService.updateInstance(item.id);
    if(item.page === 'claim')  {
      this.navigateService.navigateToPage('claim', item.id, item.type);
      return;
    }
    if(item.page === 'invoice')  {
      this.navigateService.navigateToPage('invoice', item.id, item.type);
      return;
    }

    this.router.navigate(['/' + item.route + '/' + item.page + '/' + item.id]);
  }
}

